var _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4376 16.0557V17.5557H7.81261V16.2666L11.5157 12.2275C11.922 11.7692 12.2423 11.3734 12.4767 11.04C12.711 10.7067 12.8751 10.4072 12.9689 10.1416C13.0678 9.87077 13.1173 9.60775 13.1173 9.35254C13.1173 8.99316 13.0496 8.67806 12.9142 8.40723C12.784 8.13118 12.5913 7.91504 12.336 7.75879C12.0808 7.59733 11.7709 7.5166 11.4064 7.5166C10.9845 7.5166 10.6303 7.60775 10.3439 7.79004C10.0574 7.97233 9.84125 8.22493 9.69542 8.54785C9.54959 8.86556 9.47667 9.23014 9.47667 9.6416H7.59386C7.59386 8.98014 7.7449 8.37598 8.04698 7.8291C8.34907 7.27702 8.78657 6.83952 9.35948 6.5166C9.9324 6.18848 10.6225 6.02441 11.4298 6.02441C12.1902 6.02441 12.836 6.15202 13.3673 6.40723C13.8985 6.66243 14.3022 7.02441 14.5782 7.49316C14.8595 7.96191 15.0001 8.5166 15.0001 9.15723C15.0001 9.51139 14.9428 9.86296 14.8282 10.2119C14.7137 10.5609 14.5496 10.9098 14.336 11.2588C14.1277 11.6025 13.8803 11.9489 13.5939 12.2979C13.3074 12.6416 12.9923 12.9906 12.6485 13.3447L10.1876 16.0557H15.4376Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.26736032cc9d9146f681436b416d23ba.svg";
export { ForwardRef as ReactComponent };